<div *ngIf="appContent; else howHeardLoading" class="how-heard">
    <div class="nha-sa-title">
        <h1 class="nha-primary-heading">{{appContent.resourceStrings["nha.sa.howheardtitle"] | placeholder:appContent.schoolName}}</h1>
    </div>
    <form [formGroup]="howHeardForm" *ngIf="!howHeardSuccess && !howHeardError">
        <div class="nha-row">
            <div class="nha-form-group nha-gr-12 nha-gr-6@sm">
                <label for="howHeardEmail">{{appContent.resourceStrings["nha.sa.howheardemail"]}}</label>
                <input id="howHeardEmail" type="email" class="nha-form-control" formControlName="email">
                <div *ngIf="getControl('email').invalid && (getControl('email').dirty || getControl('email').touched)" class="nha-form-error-desc">
                    <span *ngIf="getControl('email').errors.maxlength">{{appContent.resourceStrings["nha.sa.errorlongvalue"]}}</span>
                    <span *ngIf="getControl('email').errors.pattern || getControl('email').errors.required">{{appContent.resourceStrings["nha.sa.errorinvalidemail"]}}</span>
                </div>
            </div>
        </div>
        <div class="nha-row">
            <div class="nha-form-group nha-gr-12">
                <label for="howHeardResponse">{{appContent.resourceStrings["nha.sa.howheardresponse"]}}</label>
                <textarea id="howHeardResponse" class="nha-form-control" formControlName="response"></textarea>
                <div *ngIf="getControl('response').invalid && (getControl('response').dirty || getControl('response').touched)" class="nha-form-error-desc">
                    <span *ngIf="getControl('response').errors.required">{{appContent.resourceStrings["nha.sa.errorfieldrequired"]}}</span>
                    <span *ngIf="getControl('response').errors.maxlength">{{appContent.resourceStrings["nha.sa.errorlongvalue"]}}</span>
                </div>
            </div>
        </div>
        <div>
            <button class="nha-btn nha-btn-primary nha-btn-homepage" type="submit" (click)="submitHowHeard()" [disabled]="isSaving">
                <span *ngIf="!isSaving">{{appContent.resourceStrings["nha.sa.howheardsubmit"]}}</span>
                <span *ngIf="isSaving" class="nha-loading">
                    <div></div>
                </span>
            </button>
        </div>
    </form>
</div>
<div *ngIf="howHeardSuccess" class="how-heard-success">
    <h2><span class="fa fa-check-circle"></span>&nbsp;{{appContent.resourceStrings["nha.sa.howheardthanks"]}}</h2>
    <button type="button" class="nha-btn nha-btn-primary nha-btn-homepage" (click)="goToHomepage()">{{appContent.resourceStrings["nha.sa.backtohomepagebutton"]}}</button>
</div>
<div *ngIf="howHeardError" class="how-heard-error">
    <h2><span class="fa fa-exclamation-circle"></span>&nbsp;Uh Oh!</h2>
    <p>{{appContent.resourceStrings["nha.sa.howhearderror"]}}</p>
</div>
<ng-template #howHeardLoading>
    <div class="nha-loading"><div></div></div>
</ng-template>
